import { autoTrack } from 'shihuo-lib';

const SsoAutoTrack = (id, biz = {}) => {
    // 生产环境上报
    if (/^(sso\.shizhi-inc\.com)$/.test(window.location.host)) {
        autoTrack({
            channel: 'sso',
        });
    }
};

export default SsoAutoTrack;